var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineVisibilitySensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 854,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-3 -854)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.0001,
    y: 854,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 1913.5C582 1565.28 864.061 1283 1212 1283 1559.94 1283 1842 1565.28 1842 1913.5 1842 2261.72 1559.94 2544 1212 2544 864.061 2544 582 2261.72 582 1913.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 1128,
    width: 1570,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 1271.5 245.5 914.5 465.5 1271.5Z",
    stroke: "#000000",
    strokeWidth: 17.1875,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#EC6920",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineVisibilitySensor);
export default __webpack_public_path__ + "static/media/MarineVisibilitySensor.c8f9ac1a97a00fa84f89be6f14dbbb1e.svg";
export { ForwardRef as ReactComponent };